import React from "react";
import { CardText, CircularProgress } from "react-md";
import CenteredSection from "../../../common/components/CenteredSection";
import RegistrationCard from "../RegistrationCard";

const SearchingPage = () => (
  <CenteredSection size={6} offset={3}>
    <RegistrationCard
      title="Searching for your account..."
      subtitle="If you have been here before, we'll re-use your information"
    >
      <CardText>
        <CircularProgress key="progress" id="searchingProgress" />
      </CardText>
    </RegistrationCard>
  </CenteredSection>
);

SearchingPage.propTypes = {};
SearchingPage.defaultProps = {};

export default SearchingPage;



// WEBPACK FOOTER //
// ./src/registration/components/Searching/SearchingPage.jsx